import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'IW',
    name: 'Necroswarm',
    id: 'Necroswarm',
    health: 70,
    difficulty: 7,
    expeditionRating: 4,
    additionalInfo: '',
    fightFiveAdditionalInfo: `
    <p>During setup, swap one of the nemesis turn order cards for the Unleash turn order card.</p>
    <p>Play using Increased Difficulty.</p>
    <p>SETUP: Two different players each suffer 2 damage.</p>
    `,
  },
]
